import { render, staticRenderFns } from "./ProductMetaDataInput.vue?vue&type=template&id=8e88c9b2&scoped=true&"
import script from "./ProductMetaDataInput.vue?vue&type=script&lang=ts&"
export * from "./ProductMetaDataInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e88c9b2",
  null
  
)

export default component.exports